<div class="c-vehicle-avatar">
    <app-user-avatar [size]="size"
                     icon="icon-car_nav"
                     [avatar]="avatar"></app-user-avatar>
    <div class="c-ignition" *ngIf="ignition"></div>
    <div class="c-etoll" *ngIf="etoll?.enabled" [ngbTooltip]="etollTooltip" (click)="copyToClipboard()"></div>
</div>
